<template>
  <div>
    <div>
      <h4 class="mb-1 pl-2 font-weight-bold">Purchase Information</h4>
      
      <div class="purchase-invoice" v-if="details.type == 'ticket'">
        <div class="d-flex justify-content-between mb-1">
          <p class="m-0">Ticket</p>
          <p class="text-black font-weight-bold m-0">{{ details.name }}</p>
        </div>
        <div class="d-flex justify-content-between mb-1" v-if="details.addons.length">
          <p class="m-0">Add-Ons</p>
          <p class="text-black font-weight-bold m-0">
            <span v-for="(i, key) in details.addons" :key="key">  {{ i.name }}<span v-if="key !== details.addons.length - 1"> + </span></span>
          </p>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <p class="m-0">Access</p>
          <p class="text-black font-weight-bold m-0">
            <span v-for="(i, key) in details.services" :key="key">  {{ i.name }}<span v-if="key !== details.services.length - 1"> + </span></span>
          </p>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <p class="m-0">Validity</p>
          <p class="text-black font-weight-bold m-0">{{getRemainingDays(details.expire_date)}} Day(s)</p>
        </div>
      </div>

      <div class="purchase-invoice" v-if="details.type == 'package'">
        <div class="d-flex justify-content-between mb-1">
          <p class="m-0">Package</p>
          <p class="text-black font-weight-bold m-0">{{ details.name }}</p>
        </div>
        <div class="d-flex justify-content-between mb-1" v-if="details.tickets.length">
          <p class="m-0">Offer</p>
          <p class="text-black font-weight-bold m-0">
            <span v-for="(i, key) in details.tickets" :key="key">
              <span class="text-warning" v-if="i.quantity">{{ i.quantity / details.quantity }}x</span>
              <span v-else>
                <i class="las la-infinity text-warning" style="transform: rotate(0deg)!important;"></i>
              </span>
              {{i.name}}<span v-if="key !== details.tickets.length - 1"> + </span>
            </span>
          </p>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <p class="m-0">Validity</p>
          <p class="text-black font-weight-bold m-0">{{ details.promotion.validity_days }} Day(s)</p>
        </div>
      </div>
      
      <div class="purchase-invoice" v-if="details.type == 'buy_get'">
        <div class="d-flex justify-content-between mb-1">
          <p class="m-0">Buy & Get</p>
          <p class="text-black font-weight-bold m-0">{{ details.name }}</p>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <p class="m-0">Offer</p>
          <div>
            <p class="m-0" style="max-width: 270px; text-align: justify">
              <span class="text-warning font-weight-bold">Buy: </span>
              <span v-if="details.promotion.buy_get_type == 'ticket'">
                  <span v-for="(i, key) in details.promotion.tickets" :key="key">
                    <span v-if="i.count" class="text-black ">{{ i.count }}x</span>
                    <span v-else>
                      <i class="las la-infinity text-warning" style="transform: rotate(0deg)!important;"></i>
                    </span>
                    {{i.ticket.name}}<span v-if="key !== details.promotion.tickets.length - 1"> + </span>
                  </span>

              </span>         
              <span v-else>
                  <span v-for="(i, key) in details.promotion.tickets" :key="key">
                    <span v-if="i.count" class="text-black ">{{ i.count }}x</span>
                    <span v-else>
                      <i class="las la-infinity text-warning" style="transform: rotate(0deg)!important;"></i>
                    </span>
                    {{i.ticket.name}}<span v-if="key !== details.promotion.tickets.length - 1"> + </span>
                  </span>

              </span>  
            </p>

          <p class=" m-0" style="max-width: 270px; text-align: justify">
            <span class="text-warning font-weight-bold">Get: </span>
            <span v-if="details.promotion.buy_get_type == 'ticket'" >
            <span v-for="(i, key) in details.promotion.get_tickets" :key="key">
              <span v-if="i.count" class="text-black ">{{ i.count }}x</span>
              <span v-else>
                <i class="las la-infinity text-warning" style="transform: rotate(0deg)!important;"></i>
              </span>
              {{i.ticket.name}}<span v-if="key !== details.promotion.get_tickets.length - 1"> + </span>
            </span>

            </span>

             <span v-else-if="details.promotion.buy_get_type == 'coupon'">
              <span class="text-black">Coupon: {{ details.promotion.coupons[0].discount_ratio }}%  </span>
              (Applies on: <span v-for="(data, key) in getAppliedOnData(details.promotion.coupons[0])" :key="key">
                              <span v-if="key !== 0">,</span> {{ data }}
                            </span>
              )
             </span>
            <span v-if="details.promo_gift">{{ details.promo_gift }}</span>
          </p>
          
          </div>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <p class="m-0">Validity</p>
          <p class="text-black font-weight-bold m-0">{{ details.promotion.validity_days }} Day(s)</p>
        </div>
      </div>
    
    </div>
<!--    {{ details }}-->

    <div class="mt-3">
      <div class="d-flex justify-content-between">
        <h4 class="mb-1 pl-2 font-weight-bold">Purchase Invoice</h4>
        <span>Date: {{ details.created_at.substring(0,10) }}</span>
      </div>
      <div class="purchase-invoice">

        <div class="item">
          <span class="d-flex gap-1 align-items-center">
            <span class="number">{{ details.quantity }}x </span>
            <span>{{ details.name }}</span>
          </span>
          <span class="number">
            <template v-if="details.discount_offer">
              +
              <span class="number text-decoration-line-through">
                {{ details.price }} EGP
              </span>
              <span class="ml-1 number">
              {{ details.price - details.discount_offer }} EGP
              </span>
            </template>

            <template v-else>
              {{ details.price }} EGP
            </template>
        </span>
        </div>

        <template v-if="details.type == 'ticket'">

          <div class="item" v-for="(i, key) in details.addons" :key="key">
              <span class="d-flex gap-1 align-items-center" >
                <span class="number">{{ i.quantity }}x </span>
                <span>{{ i.name }}</span>
              </span>
              <span class="number">+ {{ i.final_price }} EGP</span>
          </div>

        </template>

        <div class="item" v-if="details.discount_coupon">
          <span class="coupon-text">Coupon Discount</span>
          <span class="number">- {{ details.discount_coupon }} EGP</span>
        </div>

        <div class="item total" v-for="(i, key) in details.payments" :key="key">
          <span>Total Amount  <StatusPill class="ml-2" :status="i.status" /> </span>
          <span class="number">{{ details.total_price }} EGP</span>
        </div>
        
        <div class="item" v-if="details.created_by">
          <!-- <span>Total Amount  <span> {{ details.payment_method.name }} </span></span> -->
<!--          <span></span>-->
<!--          <span></span>-->
          <span>Admin: </span>
          <span class="number">{{ details.created_by.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusPill from '@/components/core/pill.vue';
export default {
  components: {
    StatusPill
  },
  props: {
    details: {
      type: Object
    }
  },
  data () {
    return {}
  },
  methods: {
        getAppliedOnData (data)  {
      return [...data.tickets.map(ticket => ticket.name),...data.promotions.map(promotion => promotion.name)]
    },
        getRemainingDays(dateString) {
      const today = new Date();
      const targetDate = new Date(dateString);

      today.setHours(0, 0, 0, 0);
      targetDate.setHours(0, 0, 0, 0);

      const diffTime = targetDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays;
    },
  },
  watch: {},
  created () {
  }
}
</script>

<style lang="scss" scoped>
</style>
